import { type PropsWithChildren, type ReactNode } from 'react'

import { Flex } from '~/domains/platform/design-system'
import {
  ChatWhatsAppSupportButton,
  isWhatsAppSupportButtonVisible
} from '~/domains/platform/infra/chat/components/whatsapp'
import { type Subject } from '~/domains/platform/infra/deus-ex-machina/types'
import { DropdownMenu } from '~/ui/business-components/shared/dropdown-menu'
import { TopBarLayout } from '~/ui/components/layouts/top-bar-layout'

export interface TopBarOnlyContainerProps {
  subject: Subject
  children?: ReactNode
}

export function TopBarOnlyContainer(props: PropsWithChildren<TopBarOnlyContainerProps>) {
  const { subject, children } = props

  return (
    <TopBarLayout
      topBarContent={
        <Flex alignItems="center" gap="0.5rem">
          {isWhatsAppSupportButtonVisible() && <ChatWhatsAppSupportButton />}
          <DropdownMenu subject={subject} items={[]} />
        </Flex>
      }
    >
      <main id="main-content">{children}</main>
    </TopBarLayout>
  )
}
